var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: _vm.question.getItemClass(_vm.item),
      attrs: {
        tabindex: _vm.question.getItemTabIndex(_vm.item),
        "data-sv-drop-target-ranking-item": _vm.index,
      },
      on: {
        keydown: function (event) {
          _vm.question.handleKeydown.call(_vm.question, event, _vm.item)
        },
        pointerdown: function (event) {
          _vm.question.handlePointerDown.call(
            _vm.question,
            event,
            _vm.item,
            event.currentTarget
          )
        },
        pointerup: function (event) {
          _vm.question.handlePointerUp.call(
            _vm.question,
            event,
            _vm.item,
            event.currentTarget
          )
        },
      },
    },
    [
      _c(
        "div",
        { staticStyle: { outline: "none" }, attrs: { tabindex: "-1" } },
        [
          _c("div", { class: _vm.cssClasses.itemGhostNode }),
          _vm._v(" "),
          _c(
            "div",
            { class: _vm.cssClasses.itemContent },
            [
              _c("div", { class: _vm.cssClasses.itemIconContainer }, [
                _c("svg", { class: _vm.question.getIconHoverCss() }, [
                  _c("use", {
                    attrs: { "xlink:href": _vm.question.dragDropSvgIcon },
                  }),
                ]),
                _vm._v(" "),
                _c("svg", { class: _vm.question.getIconFocusCss() }, [
                  _c("use", {
                    attrs: { "xlink:href": _vm.question.arrowsSvgIcon },
                  }),
                ]),
              ]),
              _vm._v(" "),
              !_vm.unrankedItem && _vm.indexText
                ? _c(
                    "div",
                    { class: _vm.question.getItemIndexClasses(_vm.item) },
                    [_vm._v(_vm._s(_vm.indexText))]
                  )
                : _c(
                    "div",
                    { class: _vm.question.getItemIndexClasses(_vm.item) },
                    [
                      _c("svg", [
                        _c("use", {
                          attrs: { "xlink:href": _vm.question.dashSvgIcon },
                        }),
                      ]),
                    ]
                  ),
              _vm._v(" "),
              _c(_vm.question.itemComponent, {
                tag: "component",
                attrs: { item: _vm.item, cssClasses: _vm.cssClasses },
              }),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }